import { Container, Typography } from '@material-ui/core';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import NavBarUser from '../nav-bar/nav-bar-user';
import FirmProfileForm from '../profileForms/FirmProfileForm';
import PersonalProfileForm from '../profileForms/PersonalProfileForm';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import { useTranslation } from 'react-i18next';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
const useStyles = makeStyles((theme) => ({
  profile: {
    marginTop: '48px',
    color: '#1976d2',
  },
  appbar: {
    backgroundColor: '#1976d2',
    marginTop: '10px',
  },

  containeroptional: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
const UserProfile = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const token = localStorage.getItem('kss_token');
  const [user, setUser] = useState({});

  useEffect(() => {
    if (token) {
      axios
        .get(`https://account-testing-be.herokuapp.com/users/single_user`, {
          headers: {
            token: token,
          },
        })
        .then((res) => {
          setUser(res.data);
        })
        .catch((err) => {
          window.alert('some error occured please check console');
          console.log(err);
        });
    } else {
      window.alert('You are not logged in');
      window.location.replace(`https://account-kss.web.app/login`);
    }
  }, [token]);
  return (
    <BrowserRouter>
      <NavBarUser user={user} />
      {user.verified ? (
        <Container fixed>
          <Typography variant="h3" align="center" className={classes.profile}>
            {t('pages-userProfile-YourProfile')}
          </Typography>

          <AppBar position="static" className={classes.appbar}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs "
              centered
            >
              <Tab label="Personal Profile" {...a11yProps(0)} />
              <Tab label="Firm Profile" {...a11yProps(1)} />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <PersonalProfileForm data={user} token={token} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <FirmProfileForm data={user} token={token} />
          </TabPanel>
        </Container>
      ) : (
        <Container fixed className={classes.containeroptional}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" variant="subtitle1">
                {t('pages-userProfile-Please')}
              </Typography>
              <Button variant="contained" color="primary">
                {t('pages-userProfile-Resend')}
              </Button>
            </CardContent>
          </Card>
        </Container>
      )}
    </BrowserRouter>
  );
};

export default UserProfile;
